import type { StateCreator } from 'zustand';
import filterSlice, { type FiltersSliceState } from './filtersSlice';

type ManagerSlices = FiltersSliceState;

const managerSlices: StateCreator<ManagerSlices> = (setState, getState, store) => ({
  ...filterSlice(setState, getState, store),
});

export type { ManagerSlices };
export default managerSlices;
